import styled from '@mui/material/styles/styled';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import { SEVERITY_COLORS } from '../../../constants/map.constants';

export const DataGrid = styled(MuiDataGrid)(() => ({
    '.MuiDataGrid-virtualScroller': {
        overflowX: 'hidden',

        '.MuiDataGrid-virtualScrollerContent': {
            height: '100%!important',

            '.MuiDataGrid-row:hover': {
                cursor: 'pointer',
            },
        },
    },
    '.MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        outline: 'none!important',
    },
    '.MuiDataGrid-columnSeparator': {
        display: 'none',
    },
    '.MuiDataGrid-cell, .MuiDataGrid-columnHeader, .MuiDataGrid-filler div': {
        border: 'none !important',
    },
    '.MuiDataGrid-columnHeader': {
        backgroundColor: '#BADBFF',
    },
    '.MuiDataGrid-columnHeader[aria-colindex="1"]': {
        borderTopLeftRadius: '7px !important',
        borderBottomLeftRadius: '7px !important',
    },
    '.MuiDataGrid-columnHeader--last': {
        borderTopRightRadius: '7px !important',
        borderBottomRightRadius: '7px !important',
    },

    '.row-no-status': {
        borderRadius: '7px',
        border: '1px solid darkgray',
        background: '#FFFAF5',
        '&.row-selected': {
            backgroundColor: 'rgba(211,211,211,0.5)',
        },
    },

    '.row-status-0': {
        borderRadius: '7px',
        border: '1px solid ' + SEVERITY_COLORS[0],
        background: '#FFFAF5',
        '&.row-selected': {
            backgroundColor: 'rgba(0, 169, 39, 0.27)',
        },
    },

    '.row-status-100': {
        borderRadius: '7px',
        border: '1px solid ' + SEVERITY_COLORS[100],
        background: '#FFFAF5',
        '&.row-selected': {
            backgroundColor: 'rgba(255,208,0,0.27)',
        },
    },

    '.row-status-200': {
        borderRadius: '7px',
        border: '1px solid ' + SEVERITY_COLORS[200],
        background: '#FFFAF5',
        '&.row-selected': {
            backgroundColor: 'rgba(255, 0, 0, 0.25)',
        },
    },

    '.cell-status-0': {
        color: SEVERITY_COLORS[0],
        fontWeight: 900,
    },

    '.cell-status-100': {
        color: SEVERITY_COLORS[100],
        fontWeight: 900,
    },

    '.cell-status-200': {
        color: SEVERITY_COLORS[200],
        fontWeight: 900,
    },
}));
